function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  strokeWidth: ".5",
  strokeLinejoin: "bevel",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 39.6V17.36a4.6 4.6 0 014.59-4.6h1.03V8.4a4.58 4.58 0 014.57-4.58h33.24A4.58 4.58 0 0148 8.4V30.5a4.58 4.58 0 01-4.57 4.58h-.83v4.52a4.59 4.59 0 01-4.59 4.59H4.59A4.6 4.6 0 010 39.59zm39.23 0V28.74H3.37V39.6c0 .67.55 1.22 1.22 1.22h33.42c.68 0 1.22-.55 1.22-1.22zm5.4-9.1V19.7H42.6v12h.83c.66 0 1.2-.53 1.2-1.2zm-5.4-8.74v-4.4c0-.68-.55-1.22-1.22-1.22H4.6c-.67 0-1.22.55-1.22 1.22v4.4h35.86zm5.4-9V8.39c0-.67-.54-1.21-1.2-1.21H10.19c-.66 0-1.2.54-1.2 1.2v4.38h35.64z"
})));